// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconTheme.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconTheme = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 17 16" fill="currentColor" { ...props }>
    <path d="M16.5 8C16.5 3.58164 12.9184 0 8.5 0C4.08164 0 0.5 3.58164 0.5 8C0.5 12.4184 4.08164 16 8.5 16C12.9184 16 16.5 12.4184 16.5 8ZM8.5 2.56909C11.4974 2.56909 13.9309 5.00194 13.9309 8C13.9309 10.9974 11.4974 13.4309 8.5 13.4309V2.56909Z" />
  </BaseIcon>
);

export default IconTheme;
